import React, { useEffect, useRef, useState } from 'react';

const GrowthCurve = () => {
  const [isVisible, setIsVisible] = useState(false);
  const svgRef = useRef(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="relative w-full h-64 md:h-80">
      <svg
        ref={svgRef}
        viewBox="0 0 600 300"
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="curveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style={{ stopColor: '#11AAB6', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: '#052E6C', stopOpacity: 1 }} />
          </linearGradient>
        </defs>

        {/* Growth Curve Path */}
        <path
          d="M 50 250 Q 150 200, 250 150 T 550 50"
          fill="none"
          stroke="url(#curveGradient)"
          strokeWidth="3"
          strokeLinecap="round"
          className={`transition-all duration-2000 ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`}
          style={{
            strokeDasharray: 1000,
            strokeDashoffset: isVisible ? 0 : 1000,
            transition: 'stroke-dashoffset 2s ease-out'
          }}
        />

        {/* Automation Nodes */}
        {[
          { cx: 150, cy: 200, delay: 0.5 },
          { cx: 250, cy: 150, delay: 1 },
          { cx: 350, cy: 100, delay: 1.5 },
          { cx: 450, cy: 75, delay: 2 },
          { cx: 550, cy: 50, delay: 2.5 }
        ].map((node, index) => (
          <g key={index}>
            {/* Outer Ring */}
            <circle
              cx={node.cx}
              cy={node.cy}
              r="12"
              fill="none"
              stroke="#11AAB6"
              strokeWidth="2"
              className={`transition-all duration-500`}
              style={{
                opacity: isVisible ? 0.3 : 0,
                transitionDelay: `${node.delay}s`
              }}
            />
            {/* Inner Circle */}
            <circle
              cx={node.cx}
              cy={node.cy}
              r="6"
              fill="url(#curveGradient)"
              className={`transition-all duration-500`}
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'scale(1)' : 'scale(0)',
                transformOrigin: `${node.cx}px ${node.cy}px`,
                transitionDelay: `${node.delay}s`
              }}
            />
            {/* Connecting Lines to previous node */}
            {index > 0 && (
              <line
                x1={["", 150, 250, 350, 450][index]}
                y1={["", 200, 150, 100, 75][index]}
                x2={node.cx}
                y2={node.cy}
                stroke="#11AAB6"
                strokeWidth="1"
                strokeDasharray="3,3"
                className={`transition-all duration-500`}
                style={{
                  opacity: isVisible ? 0.3 : 0,
                  transitionDelay: `${node.delay - 0.2}s`
                }}
              />
            )}
          </g>
        ))}
      </svg>

      {/* Floating Metric Chips */}
      <div 
        className={`absolute top-10 right-10 md:right-20 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg border border-[#E4F5F6] transition-all duration-700 delay-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
        }`}
        style={{
          animation: isVisible ? 'float 3s ease-in-out infinite' : 'none'
        }}
      >
        <span className="font-['Space_Grotesk'] font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#11AAB6] to-[#052E6C] text-sm">+312% Leads</span>
      </div>

      <div 
        className={`absolute top-32 left-10 md:left-24 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg border border-[#E4F5F6] transition-all duration-700 delay-1500 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
        }`}
        style={{
          animation: isVisible ? 'float 3s ease-in-out infinite 0.5s' : 'none'
        }}
      >
        <span className="font-['Space_Grotesk'] font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#11AAB6] to-[#052E6C] text-sm">CRM Synced</span>
      </div>

      <div 
        className={`absolute bottom-16 right-16 md:right-32 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg border border-[#E4F5F6] transition-all duration-700 delay-2000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
        }`}
        style={{
          animation: isVisible ? 'float 3s ease-in-out infinite 1s' : 'none'
        }}
      >
        <span className="font-['Space_Grotesk'] font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#11AAB6] to-[#052E6C] text-sm">24/7 Support</span>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
};

export default GrowthCurve;
